import * as React from "react";
import { useHistory } from "react-router";
import { Button, Icon } from "semantic-ui-react";
import { get } from "lodash";

import * as DTO from "../../interfaces";
import { CampaignCard } from "@/components/Cells/CampaignCard";
import { EditableField } from "@/components/Inputs/EditableField";

import { useAccountSettings, URLS, STORAGE_KEYS } from "../../utils";
import "./styles.scss";
import { WebComponents } from "../../interfaces";

interface OwnProps {
  name: string;
  campaignList: DTO.CampaignResume[];
  category?: DTO.Category;

  page?: number;
  pageable?: boolean;
  latestPage?: boolean;
  firstPage?: boolean;

  totalElements?: number;
  disable?: boolean;

  handleCategoryChange?: (categoryName: string) => void;
  onNext?: (nextPage: number) => void;
}

type Props = OwnProps;

const CategorySectionFC: React.FC<Props> = ({
  category,
  campaignList,
  name,
  page = 0,
  disable = false,
  pageable = false,
  firstPage = true,
  latestPage = false,
  totalElements = 0,
  onNext,
  handleCategoryChange,
}) => {
  const history = useHistory();
  const [display, setDisplay] = React.useState<boolean>(true);
  const { hasWritePermission } = useAccountSettings();
  const withWritePermission = hasWritePermission(WebComponents.CAMPAIGNS);

  const actionTitle = (): string => {
    if (!display) {
      return "Collapsed (" + totalElements + ")";
    }
    return pageable
      ? `Showing ${page * 5} - ${page * 5 + campaignList.length} of ${totalElements}`
      : `Show all (${totalElements})`;
  };

  const onNextHandler = () => {
    if (onNext) {
      onNext(page + 1);
    }
  };
  const onPreviousHandler = () => {
    if (onNext) {
      onNext(page - 1);
    }
  };

  return (
    <div className="campaignsCategoryGrid flex flex-col gap-2 w-full pl-3">
      <div className={`flex items-center justify-between ${display ? "" : "collapsedSection"}`}>
        <EditableField
          headerType="h2"
          name={"campaignCategoryId" + get(category, "categoryId", name)}
          currentValue={name}
          maxLength={25}
          handleChangeValue={value => {
            if (handleCategoryChange) {
              handleCategoryChange(value);
            }
          }}
          disable={disable || !withWritePermission}
        />
        <div className="noBorder">
          <Button
            basic
            content={actionTitle()}
            icon={!display ? "triangle right" : "triangle down"}
            className="noBorder"
            labelPosition="right"
            onClick={() => setDisplay(!display)}
          />
        </div>
      </div>
      {display && (
        <div className="flex items-stretch gap-2">
          {pageable && !firstPage && (
            <Button icon="chevron left" className="leftArrowStyle" onClick={onPreviousHandler} />
          )}
          {withWritePermission && (
            <Button
              className="addButton"
              onClick={() => {
                let locationValues = {};
                const noCategories = ["unpublished", "uncategorized"];
                if (!noCategories.includes(String(category?.categoryId))) {
                  locationValues = {
                    category,
                  };
                }

                localStorage.removeItem(STORAGE_KEYS.COACH_NEW_CAMPAIGN_STEP);
                localStorage.removeItem(STORAGE_KEYS.COACH_CAMPAIGN);
                history.push(URLS.coach.newCampaigns, locationValues);
              }}
            >
              <Icon circular name="add" /> Add new
            </Button>
          )}

          <div className={"ui container p-0" + !latestPage && !firstPage ? "middlePage" : ""}>
            {campaignList.map(campaign => {
              return <CampaignCard key={"campaign_card_" + campaign.campaignId} campaign={campaign} />;
            })}
          </div>
          {pageable && !latestPage && <Button icon="chevron right" className="arrowStyle" onClick={onNextHandler} />}
        </div>
      )}
    </div>
  );
};

export const CategorySection = React.memo(CategorySectionFC);
